export default "<app-landing-header></app-landing-header>\r\n<router-outlet></router-outlet>\r\n<app-landing-footer></app-landing-footer>";